"use client";

import { usePathname, useSearchParams } from "next/navigation";
import Script from "next/script";
import { Suspense, useEffect } from "react";

import { conversionTrackingConfig } from "@/lib/conversion-tracking/config";
import { initializeOpenAiPixel } from "@/lib/conversion-tracking/providers/openai-pixel";
import { sendCAPIEvent } from "@/lib/meta-capi";
import { createEventId } from "@/utils/createEventId";

function BrowserConversionTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    initializeOpenAiPixel(pathname);
  }, [pathname]);

  useEffect(() => {
    if (!conversionTrackingConfig.metaPixelEnabled && !conversionTrackingConfig.metaCapiEnabled) return;

    const eventId = createEventId();
    const sourceUrl = window.location.href;

    if (conversionTrackingConfig.metaPixelEnabled) {
      window.fbq?.("track", "PageView", {}, { eventID: eventId });
    }
    if (conversionTrackingConfig.metaCapiEnabled) {
      void sendCAPIEvent({
        event_name: "PageView",
        event_id: eventId,
        event_source_url: sourceUrl,
      });
    }
  }, [pathname, searchParams]);

  return null;
}

export default function ConversionTrackingInit() {
  return (
    <>
      {conversionTrackingConfig.metaPixelEnabled ? <Script src="/meta-pixel-init.js" strategy="beforeInteractive" /> : null}
      <Suspense fallback={null}>
        <BrowserConversionTracker />
      </Suspense>
    </>
  );
}
